<template>
    <div height="medium" width="large">
        <div class="container">
            <div class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="user" size="medium"></common-icon>
                        <span class="card-title">
                            {{ $t('modals.patient_profile.profile.card_head') }}
                        </span>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="!isExportProfileClicked"
                            name="edit"
                            size="medium"
                            @click="editEnable('profile')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.profile"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell v-if="!isProfileEditable" width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.full_name.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.full_name.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :formData="{ fullName }"
                                valuePath="fullName"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell v-if="isProfileEditable" width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.first_name.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.first_name.placeholder')"
                                :formData="data"
                                valuePath="firstName"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell v-if="isProfileEditable" width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.last_name.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.last_name.placeholder')"
                                :formData="data"
                                valuePath="lastName"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.dob.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.dob.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="dob"
                                type="date"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.gender.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.gender.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="gender"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.marital_status.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.marital_status.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :formData="data"
                                valuePath="maritalStatus"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.language.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.language.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="preferredLanguage"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.ssn.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.ssn.placeholder')"
                                :isDisabled="!isProfileEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="ssn"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isProfileEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </div>
            <div class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="phone" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.contact_info.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="!isExportProfileClicked"
                            name="edit"
                            size="medium"
                            @click="editEnable('contact')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.contact"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell width="half">
                            <phone-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.primary_phone.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.primary_phone.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="mobilePhone"
                                type="number"
                                @change="change($event)"
                            ></phone-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.contact_info.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.contact_info.placeholder')"
                                :isDisabled="!isContactEditable"
                                :formData="data"
                                valuePath="preferredContactMethod"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <form-row>
                        <form-cell width="half">
                            <phone-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.alternate_phone.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.alternate_phone.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="homePhone"
                                type="number"
                                @change="change($event)"
                            ></phone-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.email.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.email.placeholder')"
                                :isDisabled="!isContactEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="email"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isContactEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </div>
            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="location" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.address.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="!isExportProfileClicked"
                            name="edit"
                            size="medium"
                            @click="editEnable('address')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.address"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>

                <form-wrapper @submit="handleFormSubmission()">
                    <form-row>
                        <form-cell width="half">
                            <suggest-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.street.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.street.placeholder')"
                                :suggestionsCall="addressSuggestionCall"
                                :isDisabled="!isAddressEditable"
                                :isSuggested="false"
                                :formData="data"
                                valuePath="address"
                                @change="change($event)"
                                @select="changeLocationAddress($event)"
                            ></suggest-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.addpatient.fields.floor_number.label')"
                                :placeholder="$t('forms.addpatient.fields.floor_number.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isSuggested="false"
                                :formData="data"
                                errorPath="floorNumber"
                                valuePath="floorNumber"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.addpatient.fields.apartment_number.label')"
                                :placeholder="$t('forms.addpatient.fields.apartment_number.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isSuggested="false"
                                :formData="data"
                                errorPath="apartmentNumber"
                                valuePath="apartmentNumber"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.addpatient.fields.building_number.label')"
                                :placeholder="$t('forms.addpatient.fields.building_number.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isSuggested="false"
                                :formData="data"
                                errorPath="buildingNumber"
                                valuePath="buildingNumber"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.city.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.city.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="city"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="state"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>
                    <form-row>
                        <form-cell width="half">
                            <text-field
                                class="patient-detail-form-text"
                                :label="$t('forms.patient_profile.fields.profile.address.zip.label')"
                                :placeholder="$t('forms.patient_profile.fields.profile.address.zip.placeholder')"
                                :isDisabled="!isAddressEditable"
                                :isRequired="false"
                                :formData="data"
                                valuePath="zip"
                                @change="change($event)"
                            ></text-field>
                        </form-cell>
                    </form-row>

                    <div v-if="isAddressEditable">
                        <common-buttons style="margin-top: 20px">
                            <common-button
                                :isSubmittable="false"
                                :label="$t('pages.patient.details.buttons.secondary')"
                                type="secondary"
                                @click="handleCancel"
                            ></common-button>
                            <common-button
                                :isProcessing="isSending"
                                :label="$t('pages.patient.details.buttons.primary')"
                                type="primary"
                            ></common-button>
                        </common-buttons>
                    </div>
                </form-wrapper>
            </section>

            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="emergancy" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.emergency.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="!isExportProfileClicked"
                            name="edit"
                            size="medium"
                            @click="editEnable('emergency')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.emergency"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>

                <div>
                    <div v-if="isEmergencyEditable" class="contact-card">
                        <form-wrapper @submit="handleFormSubmission()">
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.first_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.first_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.firstName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.last_name.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.last_name.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.lastName"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <phone-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.phone.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.phone.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :isRequired="false"
                                        :formData="data"
                                        valuePath="emergencyContact.phone"
                                        type="number"
                                        @change="change($event)"
                                    ></phone-field>
                                </form-cell>

                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.email"
                                        type="email"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <form-row>
                                <form-cell width="half">
                                    <text-field
                                        class="patient-detail-form-text"
                                        :label="$t('forms.patient_profile.fields.emergency.relationship.lable')"
                                        :placeholder="$t('forms.patient_profile.fields.emergency.relationship.placeholder')"
                                        :isDisabled="!isEmergencyEditable"
                                        :formData="data"
                                        valuePath="emergencyContact.relationship"
                                        @change="change($event)"
                                    ></text-field>
                                </form-cell>
                            </form-row>
                            <div v-if="isEmergencyEditable">
                                <common-buttons style="margin-top: 20px">
                                    <common-button
                                        :isSubmittable="false"
                                        :label="$t('pages.patient.details.buttons.secondary')"
                                        type="secondary"
                                        @click="handleCancel"
                                    ></common-button>
                                    <common-button
                                        :isProcessing="isSending"
                                        :label="$t('pages.patient.details.buttons.primary')"
                                        type="primary"
                                    ></common-button>
                                </common-buttons>
                            </div>
                        </form-wrapper>
                    </div>
                    <div v-if="hasEmergencyContact(data) && !isEmergencyEditable" class="contact-card">
                        <div class="main">
                            <p class="name">{{ data?.emergencyContact?.firstName }} {{ data?.emergencyContact?.lastName }}</p>
                            <div class="">
                                <span class="tag">{{ data?.emergencyContact?.relationship }}</span>
                                <span class="tag primary">Primary</span>
                            </div>
                        </div>
                        <div class="card_grid">
                            <p class="port">
                                <common-icon name="phone" size="tiny"></common-icon>
                                {{ data?.emergencyContact?.phone }}
                            </p>
                            <p class="port">
                                <common-icon name="email" size="tiny"></common-icon>
                                {{ data?.emergencyContact?.email }}
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section class="Cards">
                <div class="main-data main-card">
                    <div>
                        <common-icon name="link" size="medium"></common-icon>
                        <span class="card-title">{{ $t('modals.patient_profile.profile.pharmacy.card_head') }}</span>
                    </div>
                    <div class="edit-export">
                        <common-icon
                            v-if="!isExportProfileClicked"
                            name="edit"
                            size="medium"
                            @click="editEnable('pharmacy')"
                        ></common-icon>
                        <input
                            v-if="isExportProfileClicked"
                            v-model="selectedExportFields.pharmacy"
                            type="checkbox"
                            class="export-checkbox"
                        />
                    </div>
                </div>
                <div class="contact-card">
                    <form-wrapper v-if="isPharmacyEditable" @submit="handleFormSubmission()">
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.name.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.name.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :formData="data"
                                    valuePath="preferredFarmacy.name"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <suggest-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.address.label')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.address.placeholder')"
                                    :suggestionsCall="addressSuggestionCall"
                                    :isRequired="true"
                                    :isDisabled="!isPharmacyEditable"
                                    :isSuggested="false"
                                    :formData="data"
                                    valuePath="preferredFarmacy.address"
                                    @change="change($event)"
                                    @select="changePharmacyAddress($event)"
                                ></suggest-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.city.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.city.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredFarmacy.city"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.state.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.state.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredFarmacy.state"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.profile.address.zip.label')"
                                    :placeholder="$t('forms.patient_profile.fields.profile.address.zip.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredFarmacy.zip"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <form-row>
                            <form-cell width="half">
                                <phone-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.phone.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.phone.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :isRequired="false"
                                    :formData="data"
                                    valuePath="preferredFarmacy.phone"
                                    type="number"
                                    @change="change($event)"
                                ></phone-field>
                            </form-cell>

                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.pharmacy.fax.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.pharmacy.fax.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :formData="data"
                                    valuePath="preferredFarmacy.fax"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                            <form-cell width="half">
                                <text-field
                                    class="patient-detail-form-text"
                                    :label="$t('forms.patient_profile.fields.emergency.email.lable')"
                                    :placeholder="$t('forms.patient_profile.fields.emergency.email.placeholder')"
                                    :isDisabled="!isPharmacyEditable"
                                    :formData="data"
                                    valuePath="preferredFarmacy.email"
                                    type="email"
                                    @change="change($event)"
                                ></text-field>
                            </form-cell>
                        </form-row>
                        <div v-if="isPharmacyEditable">
                            <common-buttons style="margin-top: 20px">
                                <common-button
                                    :isSubmittable="false"
                                    :label="$t('pages.patient.details.buttons.secondary')"
                                    type="secondary"
                                    @click="handleCancel"
                                ></common-button>
                                <common-button
                                    :isProcessing="isSending"
                                    :label="$t('pages.patient.details.buttons.primary')"
                                    type="primary"
                                ></common-button>
                            </common-buttons>
                        </div>
                    </form-wrapper>
                    <div v-if="hasPreferredPharmacy(data) && !isPharmacyEditable">
                        <div class="main">
                            <p class="name">{{ data?.preferredFarmacy?.name }}</p>
                            <span class="tag green">Preferred</span>
                        </div>

                        <p class="port">
                            <common-icon name="location" size="small"></common-icon>
                            {{ data?.preferredFarmacy?.address }}, {{ data?.preferredFarmacy?.city }},
                            {{ data?.preferredFarmacy?.state }}, {{ data?.preferredFarmacy?.zip }}
                        </p>

                        <div class="card_grid">
                            <p class="port">
                                <common-icon name="phone" size="tiny"></common-icon>
                                {{ data?.preferredFarmacy?.phone }}
                            </p>
                            <p class="port">
                                <common-icon name="file" size="tiny"></common-icon>
                                {{ data?.preferredFarmacy?.fax }}
                            </p>
                        </div>

                        <p class="port">
                            <common-icon name="email" size="small"></common-icon>
                            {{ data?.preferredFarmacy?.email }}
                        </p>
                    </div>
                </div>
            </section>

            <section class="Cards">
                <div class="main-data">
                    <div class="title-group">
                        <common-icon name="building" size="medium"></common-icon>
                        <h3 class="card-title">{{ $t('modals.patient_profile.profile.providers.card_head') }}</h3>
                    </div>
                    <input
                        v-if="isExportProfileClicked"
                        v-model="selectedExportFields.providers"
                        type="checkbox"
                        class="export-checkbox"
                    />
                </div>
                <div v-for="(connection, index) in connections" :key="index" class="contact-card">
                    <p class="user-name">{{ connectionName(connection) }}</p>
                    <div class="main">
                        <p class="label">
                            <span v-if="connection?.user">
                                {{ connection?.user?.specialities[0]?.speciality.name }}
                            </span>
                        </p>
                        <div class="">
                            <span class="tag primary">{{ $t('modals.patient_profile.profile.providers.primary') }}</span>
                            <span class="tag green">{{ $t('modals.patient_profile.profile.providers.in_network') }}</span>
                        </div>
                    </div>
                    <p class="port">{{ connection.practice.name }}</p>
                    <div class="card_grid">
                        <p class="port">
                            <common-icon name="phone" size="tiny"></common-icon>
                            {{ connectionPhone(connection) }}
                        </p>
                        <p class="port">
                            <common-icon name="email" size="tiny"></common-icon>
                            {{ connectionEmail(connection) }}
                        </p>
                    </div>
                    <p class="port">
                        <common-icon name="location" size="small"></common-icon>
                        {{ connectionAddress(connection) }}
                    </p>
                </div>
            </section>

            <div v-if="isExportProfileClicked" class="export-desc">
                <p>{{ $t('pages.patient.details.text.export_txt') }}</p>
                <common-buttons>
                    <common-button
                        :isSubmittable="false"
                        :label="$t('pages.patient.details.buttons.secondary')"
                        type="secondary"
                        @click="handleCancelExport"
                    ></common-button>
                    <common-button
                        :isDisabled="!hasSelectedFields"
                        :label="$t('pages.patient.details.buttons.export')"
                        type="primary"
                        @click="openExportModal"
                    ></common-button>
                </common-buttons>
            </div>
            <div class="main-data">
                <button class="btn" @click="exportBtnClick">
                    <common-icon name="file" size="tiny"></common-icon>
                    {{ $t('pages.patient.details.buttons.export_profile') }}
                </button>
                <button class="btn">
                    <common-icon name="setting" size="tiny"></common-icon>
                    {{ $t('pages.patient.details.buttons.edit_profile') }}
                </button>
            </div>
        </div>
        <common-modal v-if="isExportModalOpen" :isOpen="isExportModalOpen" width="large" height="full" @close="closeExportModal">
            <download-profile
                :patientDetails="patientDetails"
                :exportData="buildExportData()"
                @download-pdf="closeExportModalAndClear"
            ></download-profile>
        </common-modal>
    </div>
</template>
<script>
    import FormMixin from 'mixins/FormMixin'
    import HandleRequestMixin from 'mixins/HandleRequestMixin'
    import PatientAPI from 'api/PatientAPI'
    import isEqual from 'lodash.isequal'
    import FormDisableableMixin from 'mixins/FormDisableableMixin'
    import DownloadProfile from '../../page-elements/DownloadProfile.vue'
    export default {
        mixins: [FormMixin, HandleRequestMixin, FormDisableableMixin],

        components: { DownloadProfile },

        props: {
            patientDetails: { type: Object, required: true },
        },

        data() {
            return {
                isProfileEditable: false,
                isContactEditable: false,
                isAddressEditable: false,
                isEmergencyEditable: false,
                isPharmacyEditable: false,
                maxNumberOfItems: null,
                changedFields: {},
                connections: [],
                isExportProfileClicked: false,
                isExportModalOpen: false,
                selectedExportFields: {
                    profile: false,
                    contact: false,
                    address: false,
                    emergency: false,
                    pharmacy: false,
                    providers: false,
                    preferences: false,
                    healthcare: false,
                },
            }
        },

        computed: {
            fullName() {
                return `${this.data.firstName || ''} ${this.data.lastName || ''}`.trim()
            },
            hasSelectedFields() {
                return Object.values(this.selectedExportFields).some(Boolean)
            },
            addressSuggestionCall() {
                //eslint-disable-next-line no-undef
                const autocompleteService = new google.maps.places.AutocompleteService()
                return (query) => {
                    const request = {
                        input: query,
                        componentRestrictions: { country: 'US' },
                    }
                    return autocompleteService.getPlacePredictions(request).then((results) => {
                        return results?.predictions?.map((item) => {
                            return {
                                label: item.description,
                                value: item.place_id,
                            }
                        })
                    })
                }
            },
        },

        methods: {
            exportBtnClick() {
                this.isExportProfileClicked = true
            },
            handleCancelExport() {
                this.isExportProfileClicked = false
                this.resetSelectedExportFields()
            },
            openExportModal() {
                this.isExportModalOpen = true
            },
            closeExportModal() {
                this.isExportModalOpen = false
            },
            closeExportModalAndClear() {
                this.handleCancelExport()
                this.closeExportModal()
            },
            resetSelectedExportFields() {
                Object.keys(this.selectedExportFields).forEach((key) => {
                    this.selectedExportFields[key] = false
                })
            },
            buildExportData() {
                const exportData = {}

                if (this.selectedExportFields.profile) {
                    exportData.Profile = {
                        Name: `${this.data.firstName} ${this.data.lastName}`,
                        DOB: this.data.dob,
                        Gender: this.data.gender,
                        MaritalStatus: this.data.maritalStatus,
                        Language: this.data.preferredLanguage,
                        SSN: this.data.ssn,
                    }
                }

                if (this.selectedExportFields.contact) {
                    exportData.Contact = {
                        Mobile: this.data.mobilePhone,
                        ContactMethod: this.data.preferredContactMethod,
                        Home: this.data.homePhone,
                        Email: this.data.email,
                    }
                }

                if (this.selectedExportFields.address) {
                    exportData.Address = {
                        Address: this.data.address,
                        Floor: this.data.floorNumber,
                        Apartment: this.data.apartmentNumber,
                        Building: this.data.buildingNumber,
                        City: this.data.city,
                        State: this.data.state,
                        Zip: this.data.zip,
                    }
                }

                if (this.selectedExportFields.emergency) {
                    exportData.EmergencyContact = {
                        Name: `${this.data.emergencyContact.firstName} ${this.data.emergencyContact.lastName}`,
                        Phone: this.data.emergencyContact.phone,
                        Email: this.data.emergencyContact.email,
                        Relationship: this.data.emergencyContact.relationship,
                    }
                }

                if (this.selectedExportFields.pharmacy) {
                    const { address, city, state, zip } = this.data.preferredFarmacy || {}
                    exportData.PreferredPharmacy = {
                        Name: this.data.preferredFarmacy.name,
                        Address: [address, city, state, zip].some((v) => v && v.toString().trim())
                            ? [address, city, state, zip].filter(Boolean).join(', ')
                            : 'N/A',
                        Phone: this.data.preferredFarmacy.phone,
                        Fax: this.data.preferredFarmacy.fax,
                        Email: this.data.preferredFarmacy.email,
                    }
                }
                if (this.selectedExportFields.providers) {
                    exportData.Providers = this.connections.map((connection) => ({
                        Name: this.connectionName(connection),
                        Speciality: connection?.user?.specialities?.[0]?.speciality?.name || '',
                        Practice: connection?.practice?.name || '',
                        Phone: this.connectionPhone(connection),
                        Email: this.connectionEmail(connection),
                        Address: this.connectionAddress(connection),
                    }))
                }
                return exportData
            },
            change({ path, value }) {
                this.changedFields[path] = value
                this.$set(this.data, path, value)
            },
            editEnable(type) {
                switch (type) {
                    case 'profile':
                        this.isProfileEditable = true
                        this.isContactEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'contact':
                        this.isProfileEditable = false
                        this.isContactEditable = true
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'address':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = true
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = false
                        break
                    case 'emergency':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = true
                        this.isPharmacyEditable = false
                        break
                    case 'pharmacy':
                        this.isContactEditable = false
                        this.isProfileEditable = false
                        this.isAddressEditable = false
                        this.isEmergencyEditable = false
                        this.isPharmacyEditable = true
                }
            },
            handleCancel() {
                this.resetEditStates()
            },
            resetEditStates() {
                this.isProfileEditable = false
                this.isContactEditable = false
                this.isAddressEditable = false
                this.isEmergencyEditable = false
                this.isPharmacyEditable = false
            },
            changeLocationAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }

                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        const addressComponents = {}
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zipCode = component.long_name
                                        break
                                }
                            })
                        })

                        this.$set(
                            this.data,
                            'address',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'city', addressComponents.city || '')
                        this.$set(this.data, 'state', addressComponents.state || '')
                        this.$set(this.data, 'zip', addressComponents.zipCode || '')
                        this.isSuggested = true
                    }
                })
            },
            changePharmacyAddress(payload) {
                if (!payload?.value) {
                    return
                }
                //eslint-disable-next-line no-undef
                const placesService = new google.maps.places.PlacesService(document.createElement('div'))
                const request = {
                    placeId: payload.value,
                    fields: ['address_components'],
                }
                let addressComponents = {}
                placesService.getDetails(request, (place, status) => {
                    //eslint-disable-next-line no-undef
                    if (status === google.maps.places.PlacesServiceStatus.OK) {
                        place.address_components.forEach((component) => {
                            component.types.forEach((type) => {
                                switch (type) {
                                    case 'street_number':
                                        addressComponents.streetNumber = component.long_name
                                        break
                                    case 'route':
                                        addressComponents.address = component.long_name
                                        break
                                    case 'locality':
                                        addressComponents.city = component.long_name
                                        break
                                    case 'administrative_area_level_1':
                                        addressComponents.state = component.short_name
                                        break
                                    case 'postal_code':
                                        addressComponents.zip = component.long_name
                                        break
                                }
                            })
                        })
                        this.$set(
                            this.data,
                            'preferredFarmacy.address',
                            `${addressComponents.streetNumber || ''} ${addressComponents.address || ''}`,
                        )
                        this.$set(this.data, 'preferredFarmacy.city', addressComponents.city || '')
                        this.$set(this.data, 'preferredFarmacy.state', addressComponents.state || '')
                        this.$set(this.data, 'preferredFarmacy.zip', addressComponents.zip || '')

                        this.changedFields['preferredFarmacy.address'] = `${addressComponents.streetNumber || ''} ${
                            addressComponents.address || ''
                        }`
                        this.changedFields['preferredFarmacy.city'] = addressComponents.city || ''
                        this.changedFields['preferredFarmacy.state'] = addressComponents.state || ''
                        this.changedFields['preferredFarmacy.zip'] = addressComponents.zip || ''
                    }
                })
            },
            handleFormSubmission() {
                this.isSending = true
                this.emitEvent({ name: 'is-sending', payload: this.isSending })
                const patientId = this.$route.params.id
                let payload = {}
                if (this.isProfileEditable) {
                    if (this.changedFields.firstName !== undefined) payload.firstName = this.changedFields.firstName
                    if (this.changedFields.lastName !== undefined) payload.lastName = this.changedFields.lastName
                    if (this.changedFields.dob !== undefined) payload.dob = this.changedFields.dob
                    if (this.changedFields.gender !== undefined)
                        payload.gender = this.changedFields.gender
                            ? this.changedFields.gender.toString().trim().toLowerCase()
                            : null
                    if (this.changedFields.ssn !== undefined) payload.last4ssn = this.changedFields.ssn
                    if (this.changedFields.maritalStatus !== undefined) payload.maritalStatus = this.changedFields.maritalStatus
                    if (this.changedFields.preferredLanguage !== undefined)
                        payload.preferredLanguage = this.changedFields.preferredLanguage
                }

                if (this.isContactEditable) {
                    if (this.changedFields.mobilePhone !== undefined) payload.mobilePhone = this.changedFields.mobilePhone
                    if (this.changedFields.homePhone !== undefined) payload.homePhone = this.changedFields.homePhone
                    if (this.changedFields.email !== undefined) payload.email = this.changedFields.email
                    if (this.changedFields.preferredContactMethod !== undefined)
                        payload.preferredContactMethod = this.changedFields.preferredContactMethod
                }

                if (this.isAddressEditable) {
                    payload.address = {
                        address: this.changedFields.address || this.data.address,
                        city: this.changedFields.city || this.data.city,
                        state: this.changedFields.state || this.data.state,
                        zip: this.changedFields.zip || this.data.zip,
                        floorNumber: this.changedFields.floorNumber || this.data.floorNumber,
                        apartmentNumber: this.changedFields.apartmentNumber || this.data.apartmentNumber,
                        buildingNumber: this.changedFields.buildingNumber || this.data.buildingNumber,
                    }
                }

                if (this.isEmergencyEditable) {
                    payload.emergencyContact = {
                        firstName: this.changedFields['emergencyContact.firstName'] || this.data.emergencyContact.firstName,
                        lastName: this.changedFields['emergencyContact.lastName'] || this.data.emergencyContact.lastName,
                        phone: this.changedFields['emergencyContact.phone'] || this.data.emergencyContact.phone,
                        email: this.changedFields['emergencyContact.email'] || this.data.emergencyContact.email,
                        relationship:
                            this.changedFields['emergencyContact.relationship'] || this.data.emergencyContact.relationship,
                    }
                }

                if (this.isPharmacyEditable) {
                    payload.preferredFarmacy = {
                        name: this.changedFields['preferredFarmacy.name'] || this.data.preferredFarmacy.name,
                        address: this.changedFields['preferredFarmacy.address'] || this.data.preferredFarmacy.address,
                        city: this.changedFields['preferredFarmacy.city'] || this.data.preferredFarmacy.city,
                        state: this.changedFields['preferredFarmacy.state'] || this.data.preferredFarmacy.state,
                        zip: this.changedFields['preferredFarmacy.zip'] || this.data.preferredFarmacy.zip,
                        phone: this.changedFields['preferredFarmacy.phone'] || this.data.preferredFarmacy.phone,
                        fax: this.changedFields['preferredFarmacy.fax'] || this.data.preferredFarmacy.fax,
                        email: this.changedFields['preferredFarmacy.email'] || this.data.preferredFarmacy.email,
                    }
                }

                this.handleRequest(PatientAPI.updatePatientDetails(patientId, this.$auth.getUser().id, payload))
                    .then(() => {
                        this.resetEditStates()
                    })
                    .finally(() => {
                        this.isSending = false
                        this.emitEvent({ name: 'update-patientDetails' })
                        this.resetEditStates()
                    })
            },
            getPatientConnections() {
                const patientId = this.$route.params.id
                PatientAPI.getProviderPatientConnections(patientId, {}, { limit: 3, offset: 0 }).then((res) => {
                    this.connections = res
                })
            },
            connectionName(item) {
                if (item.user) {
                    return `${item.user.designation} ${item.user.firstName} ${item.user.lastName}`
                }
                return item.practice?.name || ''
            },
            connectionPhone(item) {
                if (item.user) {
                    return `${item.user.phone}`
                }
                return item.practice?.phone || ''
            },
            connectionEmail(item) {
                if (item.user) {
                    return `${item.user.email}`
                }
                return item.practice?.email || ''
            },
            connectionAddress(item) {
                return `${item?.practice?.address}, ${item?.practice?.city}, ${item?.practice?.state} ${item?.practice?.zip}`
            },
            hasEmergencyContact(item) {
                const e = item?.emergencyContact
                return !!(e && (e.firstName || e.lastName))
            },
            hasPreferredPharmacy(item) {
                const e = item?.preferredFarmacy
                return !!(e && (e.name || e.address || e.phone))
            },
            setNumberOfItems() {
                if (this.isTablet) {
                    this.maxNumberOfItems = 1
                    return
                }
                if (this.isLaptop) {
                    this.maxNumberOfItems = 2
                    return
                }

                this.maxNumberOfItems = 3
            },
        },

        watch: {
            patientDetails: {
                handler(newVal) {
                    if (!newVal || !Object.keys(newVal).length) return
                    if (
                        this.isProfileEditable ||
                        this.isContactEditable ||
                        this.isAddressEditable ||
                        this.isEmergencyEditable ||
                        this.isPharmacyEditable
                    ) {
                        return
                    }

                    if (newVal && Object.keys(newVal).length) {
                        this.data = {
                            ...this.data,
                            firstName: newVal.firstName || '',
                            lastName: newVal.lastName || '',
                            dob: newVal.dateOfBirth || null,
                            gender: newVal?.mcard?.gender
                                ? newVal?.mcard?.gender.charAt(0).toUpperCase() + newVal?.mcard?.gender.slice(1)
                                : '',
                            maritalStatus: newVal?.mcard?.maritalStatus || '',
                            ssn: newVal.ssn || null,
                            preferredLanguage: newVal?.mcard?.preferredLanguage || '',
                            mobilePhone: newVal?.mobilePhone || null,
                            homePhone: newVal?.homePhone || null,
                            email: newVal.email || '',
                            address: newVal.address || '',
                            floorNumber: newVal.floorNumber || '',
                            apartmentNumber: newVal.apartmentNumber || '',
                            buildingNumber: newVal.buildingNumber || '',
                            city: newVal.city || '',
                            state: newVal.state || '',
                            zip: newVal.zip || '',
                            preferredContactMethod: newVal?.mcard?.preferredContactMethod || '',
                            emergencyContact: {
                                firstName: newVal.mcard?.emergencyContact?.firstName || '',
                                lastName: newVal.mcard?.emergencyContact?.lastName || '',
                                phone: newVal.mcard?.emergencyContact?.phone || '',
                                email: newVal.mcard?.emergencyContact?.email || '',
                                relationship: newVal.mcard?.emergencyContact?.relationship || '',
                            },
                            preferredFarmacy: {
                                name: newVal?.mcard?.preferredFarmacy?.name || '',
                                address: newVal?.mcard?.preferredFarmacy?.address || '',
                                city: newVal?.mcard?.preferredFarmacy?.city || '',
                                state: newVal?.mcard?.preferredFarmacy?.state || '',
                                zip: newVal?.mcard?.preferredFarmacy?.zip || '',
                                phone: newVal?.mcard?.preferredFarmacy?.phone || '',
                                fax: newVal?.mcard?.preferredFarmacy?.fax || '',
                                email: newVal?.mcard?.preferredFarmacy?.email || '',
                            },
                        }
                    }
                },
                immediate: true,
                deep: false,
            },
            windowWidth() {
                this.setNumberOfItems()
            },
        },

        mounted() {
            this.setNumberOfItems()
            this.$on('local:afterChange', () => {
                this.emitEvent({ name: 'form-changed', payload: !isEqual(this.initialData, this.data) })
            })
            this.getPatientConnections()
        },
    }
</script>

<style scoped>
    .Cards {
        border: 1px solid #ddd;
        border-radius: 8px;
        padding: 16px;
        margin-bottom: 20px;
        background: #fff;
    }
    i.check {
        color: #0fa34d;
    }
    .badge {
        border: 1px solid #ddd !important;
        background-color: #fff !important;
        padding: 3px 11px;
        border-radius: 6px;
        color: oklch(0.145 0 0);
    }
    .btn svg {
        margin-right: 12px;
    }
    .btn {
        border: 1px solid #ccc;
        border-radius: 6px;
        padding: 6px 12px;
        cursor: pointer;
        font-size: 13px;
        display: flex;
        align-items: center;
        gap: 6px;
        margin-right: 12px;
    }
    .main {
        display: flex;
        justify-content: space-between;
        width: 100%;
        align-items: center;
    }
    .main-data {
        display: flex;
        align-items: center;
    }
    .port {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 12px;
        color: oklch(0.145 0 0);
    }
    .card-title {
        font-size: 14px;
        font-weight: 400;
        margin: 6px 6px;
        color: oklch(0.145 0 0);
    }
    .row {
        display: flex;
        flex-wrap: wrap;
        margin: 12px 1px;
    }
    .value {
        margin: 1px 0px;
    }
    .col {
        flex: 1;
        min-width: 200px;
        margin-right: 20px;
    }
    .card_grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 12px;
    }
    .card_grids {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
        gap: 12px;
        margin-top: 12px;
        width: 75%;
    }
    .value {
        font-size: 12px;
        color: oklch(0.145 0 0);
    }
    .label {
        color: oklch(0.446 0.03 256.802);
        font-weight: 500;
    }

    .name {
        font-weight: 500;
        font-size: 14px;
        margin-bottom: 14px;
        color: oklch(0.145 0 0);
    }
    .user-name {
        font-weight: 500;
        font-size: 16px;
        color: oklch(0.145 0 0);
    }
    .contact-card {
        border: 1px solid #eee;
        border-radius: 6px;
        padding: 12px;
        margin-bottom: 10px;
    }

    .tag {
        display: inline-block;
        border: 1px solid #ddd;
        padding: 2px 8px;
        border-radius: 7px;
        font-size: 12px;
        margin-right: 5px;
    }

    .tag.primary {
        background: #e3e8ff;
        color: #2f4eff;
    }

    .tag.green {
        background: #e0f7e9;
        color: #1a8f4a;
    }
    @media screen and (max-width: 600px) {
        .col {
            margin-top: 12px;
        }
        .card_grid {
            display: block !important;
        }
        .card_grids {
            grid-template-columns: repeat(2, 1fr);
        }
        .card-grid-title {
            width: 196px;
        }
    }
    .main-card {
        display: flex;
        justify-content: space-between;
    }
    .edit-export {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .title-group {
        display: flex;
        align-items: center;
        gap: 8px;
    }
    .export-checkbox {
        margin-left: auto;
    }
    .export-desc {
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 8px;
    }
</style>
